<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection title="Detail Usulan KPI">
            <div class="text-right">
              <!-- <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div> -->


              <div class="d-flex gap-3">
                <router-link :to="{ name: 'Usulan Kpi' }">
                  <button class="btn-action btn-action--secondary">
                    Kembali
                  </button>
                </router-link>
                
              </div>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
            <cards title="Form Realisasi KPI" :withmin="false">
              <div class="d-flex gap-4">
                <div class="bg-secondary rounded-2 p-0" style="width: 92px !important; height: 92px !important; "></div>
                
                <div class="d-flex flex-column gap-3 w-100">
                  <div class="row ">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Nama</span>
                      <span>{{ employee?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Jabatan</span>
                      <span>{{ employee?.jabatan || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Unit Kerja</span>
                      <span>{{ employee?.unitkerja || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Direct Supervisor</span>
                      <span>{{ employee?.direct_supervisor || '-' }}</span>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">No</span>
                      <span>{{ employee?.nip || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Posisi</span>
                      <span>{{ employee?.position || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Periode KPi</span>
                      <span>{{ periode_active?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Immediate Supervisor</span>
                      <span>{{ employee?.immediate_supervisor || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="callout-usulan-kpi">
                <div class="flex-grow-1">
                    <strong>Konfirmasi Usulan KPI</strong>
                    <p>Periksa dengan Teliti Data Usulan yang Diajukan, Kemudian Lakukan Konfirmasi!</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <button class="btn-action btn-action--reject" @click="submit(false)">Tolak</button>
                  <button class="btn-action btn-action--primary" @click="submit(true)">Terima</button>
                </div>
              </div>
            </cards>
        </GridCol>
        
        <GridCol :size="12">
          <cards class="mt-4 card--tabs" :p="0">

            <tabbed-pane
              :tabs="tabs"
            >
              <div class="tab-pane fade show active p-4 pt-0"
                id="pills-additional"
                role="tabpanel"
                aria-labelledby="pills-additional-tab"
              >
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Kinerja Tambahan</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <template v-for="(item, i) in kpi?.additional" :key="i">
                  <div class="d-flex justify-content-between items-center">
                    <div class="d-flex gap-2 items-center">
                      <h4 class="text-lg">{{ item?.title || '-' }}</h4>
                      <span v-if="item?.perspektif" class="text-capitalize">- {{ item.perspektif }}</span>
                    </div>
                    <span>{{ sumBobotSubKpi(item?.child || []) }}</span>
                  </div>
                  
                  <table
                    class="table border rounded-2 rounded-top mt-4"
                    :class="{ 'mb-5': (i + 1) !== kpi.length }"
                  >
                    <thead>
                      <tr style="background-color: #E4E9EF;">
                        <th class="text-secondary text-xs">Sub KPI</th>
                        <th class="text-secondary text-xs" width="140px">Target</th>
                        <th class="text-secondary text-xs" width="140px">Bobot</th>
                        <th class="text-secondary text-xs" width="140px">Aspek</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sub, index) in item?.child" :key="index">
                        <td class="font-weight-bolder p-4">{{ sub?.title || '-' }}</td>
                        <td class="py-4">
                          <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  style: 'currency',
                                  currency: 'IDR',
                                  minimumFractionDigits: 0,
                                }).format(sub?.target || '0')
                              }}
                            </span>
                            <span v-else>
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  minimumFractionDigits: 0,
                                }).format(sub?.target || '0')
                              }} 
                              <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '-' }}</span>
                            </span>
                        </td>
                        <td class="py-4">{{ sub?.bobot ? sub.bobot +'%' : '-' }}</td>
                        <td class="py-4">
                          <button
                            @click="openKpiDetail(true, i, index);"
                            type="button"
                            class="btn btn-outline-secondary w-100 mb-0 btn-xs"
                            data-bs-toggle="modal"
                            data-bs-target="#detailAspekModal"
                          >
                            Detail
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class="mt-4 d-flex justify-content-end">
                    <button
                      v-if="!$route.params?.id"
                      @click="chooseKpi(item)"
                      :disabled="!item?.child || item?.child?.[0] === null"
                      type="button"
                      class="btn btn-outline-secondary"
                      data-bs-toggle="modal"
                      data-bs-target="#kpiModal"
                    >Ubah</button>
                  </div> -->

                  <!-- <hr v-if="(i+1) !== kpi.length" class="mb-4" /> -->
                </template>

                <!-- Modal detail aspek -->
                <div class="modal fade" id="detailAspekModal" tabindex="-1" aria-labelledby="detailAspekModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailAspekModalLabel">Detail Aspek Penilaian</h5>
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        <!-- <pre>{{ sub_kpi_selected }}</pre> -->
                        
                        <h4 class="text-lg">Nama Aspek KPI</h4>
                        <!-- <p>Contoh “Nominal Transaksi Luar Negeri”</p> -->
                        <div class="form-control">{{ sub_kpi_selected?.title || '-' }}</div>

                        <div
                          v-for="(item) in 5"
                          :key="item"
                          class="border rounded-2 p-2 mt-4"
                        >
                          <h4 class="text-lg">Nilai {{ item }}</h4>
                          <div class="row">
                            <div class="col-6">
                              <p>Nilai minimal</p>
                              <div class="row w-100">
                                <form-group
                                  label="Operator"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_min_operator'] || '-' }}
                                  </div>
                                </form-group>

                                <form-group
                                  label="Angka"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_min'] || '-' }}
                                  </div>
                                </form-group>
                              </div>
                            </div>

                            <div class="col-6">
                              <p>Nilai maksimal</p>
                              <div class="row w-100">
                                <form-group
                                  label="Operator"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_max_operator'] || '-' }}
                                  </div>
                                </form-group>

                                <form-group
                                  label="Angka"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_max'] || '-' }}
                                  </div>
                                </form-group>
                              </div>
                            </div>
                          </div>
                        </div>

                        <h4 class="text-lg mt-5">Aspek Kinerja</h4>
                        <div class="row w-100">
                          <form-group class="form-group col-4" label="Target">
                            <div class="form-control">
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  style: 'currency',
                                  currency: 'IDR',
                                  minimumFractionDigits: 0,
                                }).format(sub_kpi_selected?.target || '0')
                              }}
                            </div>
                          </form-group>

                          <form-group class="form-group col-4" label="Satuan Target">
                            <div class="form-control text-capitalize">{{ getSatuan(sub_kpi_selected?.satuan) || '-' }}</div>
                          </form-group>

                          <form-group class="form-group col-4" label="Bobot">
                            <div class="input-group">
                              <div class="form-control">{{ sub_kpi_selected?.bobot || '-' }}</div>
                              <span class="input-group-text">%</span>
                            </div>
                          </form-group>
                        </div>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" ref="closeModalAddNewAspek">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!is_add_note"
                  class="d-flex justify-content-end gap-4"
                  @click="is_add_note = !is_add_note"
                >
                  <button type="button" class="btn btn-outline-secondary">Berikan Catatan</button>
                </div>

                <form-group
                  v-if="is_add_note"
                  label="Tulis Catatan"
                >
                  <p class="text-sm">Beri catatan untuk koreksi</p>
                  <textarea class="form-control" rows="5" placeholder="Tulis catatan disini" v-model="note"></textarea>
                </form-group>
              </div>

              <div class="tab-pane fade show p-4 pt-0"
                id="pills-master"
                role="tabpanel"
                aria-labelledby="pills-master-tab"
              >
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Kinerja</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <template v-for="(item, i) in kpi?.master" :key="i">
                  <div class="d-flex justify-content-between items-center">
                    <div class="d-flex gap-2 items-center">
                      <h4 class="text-lg">{{ item?.title || '-' }}</h4>
                      <span v-if="item?.perspektif" class="text-capitalize">- {{ item.perspektif }}</span>
                    </div>
                    <span>{{ sumBobotSubKpi(item?.child || []) }}</span>
                  </div>
                  
                  <table
                    class="table border rounded-2 rounded-top mt-4"
                    :class="{ 'mb-5': (i + 1) !== kpi.length }"
                  >
                    <thead>
                      <tr style="background-color: #E4E9EF;">
                        <th class="text-secondary text-xs">Sub KPI</th>
                        <th class="text-secondary text-xs" width="140px">Target</th>
                        <th class="text-secondary text-xs" width="140px">Bobot</th>
                        <th class="text-secondary text-xs" width="140px">Aspek</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sub, index) in item?.child" :key="index">
                        <td class="font-weight-bolder p-4">{{ sub?.title || '-' }}</td>
                        <td class="py-4">
                          <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                            {{
                              new Intl.NumberFormat('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                              }).format(sub?.target || '0')
                            }}
                          </span>
                          <span v-else>
                            {{
                              new Intl.NumberFormat('id-ID', {
                                minimumFractionDigits: 0,
                              }).format(sub?.target || '0')
                            }} 
                            <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '-' }}</span>
                          </span>
                        </td>
                        <td class="py-4">{{ sub?.bobot ? sub.bobot +'%' : '-' }}</td>
                        <td class="py-4">
                          <button
                            @click="openKpiDetail(true, i, index, 'master');"
                            type="button"
                            class="btn btn-outline-secondary w-100 mb-0 btn-xs"
                            data-bs-toggle="modal"
                            data-bs-target="#detailAspeMasterkModal"
                          >
                            Detail
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class="mt-4 d-flex justify-content-end">
                    <button
                      v-if="!$route.params?.id"
                      @click="chooseKpi(item)"
                      :disabled="!item?.child || item?.child?.[0] === null"
                      type="button"
                      class="btn btn-outline-secondary"
                      data-bs-toggle="modal"
                      data-bs-target="#kpiModal"
                    >Ubah</button>
                  </div> -->

                  <!-- <hr v-if="(i+1) !== kpi.length" class="mb-4" /> -->
                </template>

                <!-- Modal detail aspek -->
                <div class="modal fade" id="detailAspeMasterkModal" tabindex="-1" aria-labelledby="detailAspeMasterkModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailAspeMasterkModalLabel">Detail Aspek Penilaian</h5>
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        <!-- <pre>{{ sub_kpi_selected }}</pre> -->
                        
                        <h4 class="text-lg">Nama Aspek KPI</h4>
                        <!-- <p>Contoh “Nominal Transaksi Luar Negeri”</p> -->
                        <div class="form-control">{{ sub_kpi_selected?.title || '-' }}</div>

                        <div
                          v-for="(item) in 5"
                          :key="item"
                          class="border rounded-2 p-2 mt-4"
                        >
                          <h4 class="text-lg">Nilai {{ item }}</h4>
                          <div class="row">
                            <div class="col-6">
                              <p>Nilai minimal</p>
                              <div class="row w-100">
                                <form-group
                                  label="Operator"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_min_operator'] || '-' }}
                                  </div>
                                </form-group>

                                <form-group
                                  label="Angka"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_min'] || '-' }}
                                  </div>
                                </form-group>
                              </div>
                            </div>

                            <div class="col-6">
                              <p>Nilai maksimal</p>
                              <div class="row w-100">
                                <form-group
                                  label="Operator"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_max_operator'] || '-' }}
                                  </div>
                                </form-group>

                                <form-group
                                  label="Angka"
                                  class="form-group col-6"
                                >
                                  <div class="form-control">
                                    {{ sub_kpi_selected?.aspek_kinerja?.[0]?.['nilai'+ item +'_max'] || '-' }}
                                  </div>
                                </form-group>
                              </div>
                            </div>
                          </div>
                        </div>

                        <h4 class="text-lg mt-5">Aspek Kinerja</h4>
                        <div class="row w-100">
                          <form-group class="form-group col-4" label="Target">
                            <div class="form-control">
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  style: 'currency',
                                  currency: 'IDR',
                                  minimumFractionDigits: 0,
                                }).format(sub_kpi_selected?.target || '0')
                              }}
                            </div>
                          </form-group>

                          <form-group class="form-group col-4" label="Satuan Target">
                            <div class="form-control text-capitalize">{{ getSatuan(sub_kpi_selected?.satuan) || '-' }}</div>
                          </form-group>

                          <form-group class="form-group col-4" label="Bobot">
                            <div class="input-group">
                              <div class="form-control">{{ sub_kpi_selected?.bobot || '-' }}</div>
                              <span class="input-group-text">%</span>
                            </div>
                          </form-group>
                        </div>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tabbed-pane>
          </cards>

        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import EmployeeApi from "@/repository/api/EmployeeApi";
// import Select2 from 'vue3-select2-component';
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from "@/components/InputForm.vue";

import KpiUsulanApi from '@/repository/api/KpiUsulanApi';
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";

export default {
  name: "realisasi-target",
  components: {
    // FieldsetComponent,
    FormGroup,
    Cards,
    TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },
  data() {
    return {
      kpi: null,
      employee: null,
      is_add_note: false,
      note: '',
      periode_active: null,
      sub_kpi_selected: null,

      tabs: {
        'Additional': true,
        'Master': false,
      },
      satuan_target: [
        {
          value: 'rupiah',
          label: 'Rupiah'        
        },
        {
          value: 'persen',
          label: 'Persen/Hari/Skala Nilai'        
        },
        {
          value: 'pcs',
          label: 'Pcs'        
        }
      ],
    };
  },
  computed: {
    employee_id() {
      return this.$route.params?.employee_id;
    },
    periode_id() {
      return this.$route.params?.periode_id;
    },
  },
  methods: {
    async getKpiPeriode() {
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getData() {
      this.data = null;

      this.$store.state.loading = true;
      
      // await KpiUsulanApi.get(this.$route.params.id)
      await KpiUsulanApi.getDetail({
        // employee: this.employee_id,
        employee_id: this.employee_id,
        periode_id: this.periode_id,
      })
        .then((resp) => {
          // console.log(resp?.data)
          this.employee = resp?.data?.employee;
          this.kpi = resp?.data?.kpi;
        })
        .catch((err) => {
          console.log(err)
        });
        
      this.$store.state.loading = false;
    },
    
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },

    openKpiDetail(is_open=false, index_kpi=null, index_child=null, type='additional') {
      if (is_open) {
        this.sub_kpi_selected = this.kpi[type][index_kpi].child[index_child];
      } else {
        this.sub_kpi_selected = null;
      }
    },

    async submit(is_accept = false) {
      if (!is_accept && (!this.is_add_note || this.note.length === 0)) {
        this.$swal({
          icon: "error",
          title: "Catatan",
          text: "Catatan wajib diisi jika ditolak.",
        });

        return;
      }
      
      this.$store.state.loading = true;
      let assignmentkpi_id = [];

      for (let i = 0; i < this.kpi.additional.length; i++) {
        const item = this.kpi.additional[i];
        if (item?.child) {
          for (let j = 0; j < item.child.length; j++) {
            const item_sub = item.child[j];
            if (item_sub?.assignment_id) assignmentkpi_id.push(item_sub.assignment_id);
          }
          
        }
      }

      this.$swal({
        icon: "warning",
        title: 'Apakah anda yakin ingin '+ (is_accept ? 'menerima' : 'menolak') +' usulan kpi?',
        showCancelButton: true,
      })
        .then(async (result) => {
          if (result.isConfirmed) {

            let params = {
              assignmentkpi_id: JSON.stringify(assignmentkpi_id),
              aksi: (is_accept ? 'terima' : 'tolak'),
            };

            if (!is_accept) params.catatan = this.note;

            await KpiUsulanApi.action(params)
              .then(() => {
                this.$swal({
                  icon: "success",
                  title: "Usulan KPI berhasil "+ (is_accept ? 'diterima' : 'ditolak')
                });

                this.$router.push({ name: 'Usulan Kpi' })
              }).catch((error) => {
                this.$swal({
                  icon: "error",
                  title: "Error",
                  text: error?.response?.data?.message,
                });
              });
          }
        });

      this.$store.state.loading = false;
    },
    getSatuan(satuan) {
      let result = null
      try {
        result = this.satuan_target.find(({ value }) => value === satuan);
        result = result.label
      } catch (error) {
        result = satuan
      }
      return result
    }
  },
  async mounted() {
    this.getKpiPeriode();
    this.getData();
  },
};
</script>
    
<style lang="scss">
.callout-usulan-kpi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d0d4df;
  border-radius: 4px;
  padding: 24px;
  margin-top: 24px;
  p {
    margin-bottom: 0;
  }
}
</style>